"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerManager = void 0;
const logic_types_1 = require("../logic-types");
const player_1 = require("./player");
const croupier_1 = require("./croupier");
const logic_metrics_1 = require("../logic-metrics");
class PlayerManager {
    get currentPlayer() {
        const player = this.players.get(this.currentPlayerId);
        if (!player) {
            throw new Error("No current player is set or player does not exist.");
        }
        return player;
    }
    get hasSinglePlayer() {
        return this.players.size <= 1;
    }
    get hasWinningHands() {
        return this.allPlayers.some((player) => !player.isBust);
    }
    get allPlayers() {
        return Array.from(this.players.values());
    }
    get hasMaximumPlayers() {
        return this.players.size === logic_metrics_1.LogicMetrics.MaximumPlayers;
    }
    getCurrentPlayerId() {
        return this.currentPlayerId;
    }
    constructor(board, logicEventQueue, logicVersion) {
        this.board = board;
        this.logicEventQueue = logicEventQueue;
        this.logicVersion = logicVersion;
        this.players = new Map();
        this.temporaryPlayer = null;
        this.croupier = new croupier_1.Croupier(board, logicVersion);
        this.currentPlayerId = logic_types_1.PileId.Player1;
        this.players.set(this.currentPlayerId, new player_1.Player(this.currentPlayerId, board, logicVersion));
    }
    playerFromId(playerId) {
        const player = this.players.get(playerId);
        if (!player) {
            throw new Error("Player not available");
        }
        return player;
    }
    resetPlayers(instant) {
        this.currentPlayerId = logic_types_1.PileId.Player1;
        this.players.clear();
        this.players.set(this.currentPlayerId, new player_1.Player(this.currentPlayerId, this.board, this.logicVersion));
        this.logicEventQueue.enqueue({
            type: "onCurrentPlayerChanged",
            instant,
            payload: { player: this.currentPlayer.clone() },
        });
    }
    playerNextTurn(playerId) {
        const allPlayerIds = [
            logic_types_1.PileId.Player1,
            logic_types_1.PileId.Player2,
            logic_types_1.PileId.Player3,
            logic_types_1.PileId.Player4,
        ];
        const foundIndex = allPlayerIds.indexOf(playerId);
        if (foundIndex === -1) {
            return undefined;
        }
        const nextIndex = foundIndex + 1;
        const nextPlayerId = allPlayerIds[nextIndex] !== undefined
            ? allPlayerIds[nextIndex]
            : undefined;
        if (!nextPlayerId) {
            return undefined;
        }
        return this.players.get(nextPlayerId);
    }
    moveToNextPlayer(nextPlayerId, instant) {
        this.currentPlayerId = nextPlayerId;
        this.logicEventQueue.enqueue({
            type: "onMoveNextPlayer",
            instant,
            payload: { player: this.currentPlayer.clone() },
        });
    }
    createNextAvailablePlayer(betAmount) {
        const playerId = this.getNextAvailablePlayerId();
        if (!playerId) {
            return undefined;
        }
        this.temporaryPlayer = new player_1.Player(playerId, this.board, this.logicVersion);
        this.temporaryPlayer.setBetAmount(betAmount);
        return this.temporaryPlayer;
    }
    clearNextAvailablePlayer() {
        this.temporaryPlayer = null;
    }
    commitNextAvailablePlayer() {
        if (!this.temporaryPlayer) {
            throw new Error("No temporary player to commit.");
        }
        if (this.players.has(this.temporaryPlayer.playerId)) {
            throw new Error(`Player with ID ${this.temporaryPlayer.playerId} already exists.`);
        }
        this.players.set(this.temporaryPlayer.playerId, this.temporaryPlayer);
        this.temporaryPlayer = null; // Clear temporary player after committing
    }
    setCurrentPlayerComplete(instant) {
        // Set current player state they have finished dealing
        this.currentPlayer.setHandComplete(true);
        this.logicEventQueue.enqueue({
            type: "onPlayerHandComplete",
            instant,
            payload: { player: this.currentPlayer.clone() },
        });
    }
    setDoubleBet(player, instant) {
        player.setDoubleBet(true);
        this.logicEventQueue.enqueue({
            type: "onBetDoubled",
            instant,
            payload: { player: player.clone() },
        });
    }
    getNextAvailablePlayerId() {
        const allPlayerIds = [
            logic_types_1.PileId.Player1,
            logic_types_1.PileId.Player2,
            logic_types_1.PileId.Player3,
            logic_types_1.PileId.Player4,
        ];
        for (const playerId of allPlayerIds) {
            if (!this.players.has(playerId)) {
                return playerId;
            }
        }
        return undefined;
    }
}
exports.PlayerManager = PlayerManager;
